import { getWarpStyledBoldHtml, checkForUnhandeledTags } from './utils.js';

export type Props = {
    text: string;
    className?: string;
    altText?: string;
    as?: React.ElementType;
};

/**
 * Sanitizing paragraphs that are provided form the api, and switching
 * out styling with Warp structure.
 *
 * @param {string} text html string to be cleaned
 * @param {className} string css class for any additional style
 * @param {altText} string alternative for screen readers. Will hide the main text.
 * @returns {node} an html element with the text injected
 *
 */

const SanitizedText = ({ text, className, altText, as: Tag = 'p' }: Props) => {
    const warpStyledHTML = getWarpStyledBoldHtml(text);
    checkForUnhandeledTags(text, !!altText);

    return (
        <>
            <Tag
                className={className}
                dangerouslySetInnerHTML={{
                    __html: warpStyledHTML,
                }}
                aria-hidden={!!altText}
            ></Tag>
            {altText && <Tag className="sr-only">{altText}</Tag>}
        </>
    );
};

export default SanitizedText;
